import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryV1 } from './baseQueryV1';

export const employeeRulesApi = createApi({
  reducerPath: 'employeeRulesApi',
  baseQuery: baseQueryV1,
  tagTypes: ['EmployeeRules'],
  endpoints: (builder) => ({
    getEmployeeRules: builder.query({
      query: (params) => ({
        url: 'employee-rules',
        method: 'GET',
        params,
      }),
      providesTags: ['EmployeeRules'],
      transformResponse: (res) => res?.data,
    }),
    addEmployeeRule: builder.mutation({
      query: (payload) => {
        const formData = new FormData();
        formData.append('title', payload.title);
        formData.append('type', payload.type);
        formData.append('scope', JSON.stringify(payload.scope));

        if (payload.type === 'TEXT') {
          formData.append('rules', JSON.stringify(payload.rules));
        } else if (payload.type === 'FILE' && payload.file) {
          formData.append('file', payload.file);
        }

        return {
          url: 'employee-rules',
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: ['EmployeeRules'],
      transformResponse: (res) => res?.data,
    }),
    deleteEmployeeRule: builder.mutation({
      query: (id) => ({
        url: `employee-rules/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['EmployeeRules'],
      transformResponse: (res) => res?.data,
    }),
    updateEmployeeRule: builder.mutation({
      query: ({ id, ...payload }) => {
        const formData = new FormData();
        formData.append('title', payload.title);
        formData.append('type', payload.type);
        formData.append('scope', JSON.stringify(payload.scope));

        if (payload.type === 'TEXT') {
          formData.append('rules', JSON.stringify(payload.rules));
        } else if (payload.type === 'FILE' && payload.file) {
          formData.append('file', payload.file);
        }

        return {
          url: `employee-rules/${id}`,
          method: 'PATCH',
          body: formData,
        };
      },
      invalidatesTags: ['EmployeeRules'],
      transformResponse: (res) => res?.data,
    }),
    getEmployeeViewRules: builder.query({
      query: () => ({
        url: 'employee-rules/employee-view',
        method: 'GET',
      }),
      transformResponse: (res) => res?.data,
    }),
    markRuleAsRead: builder.mutation({
      query: ({ id, payload }) => ({
        url: `employee-rules/mark-as-read/${id}`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['EmployeeRules'],
      transformResponse: (res) => res?.data,
    }),
    getEmployeeRuleById: builder.query({
      query: (id) => ({
        url: `employee-rules/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{ type: 'EmployeeRules', id }],
      transformResponse: (res) => res?.data,
    }),
  }),
});

export const {
  useGetEmployeeRulesQuery,
  useAddEmployeeRuleMutation,
  useDeleteEmployeeRuleMutation,
  useUpdateEmployeeRuleMutation,
  useGetEmployeeViewRulesQuery,
  useMarkRuleAsReadMutation,
  useGetEmployeeRuleByIdQuery,
} = employeeRulesApi;
